<template>
  <div class="bg-white" style="height:100%" v-if="viewModel">
    <div class="mb-3 d-flex  bg-light-fracture1 ">
      <div class="pl-3 pt-3 pb-2">
        <h3 >{{$t("最近使用.1")}}</h3>
      </div>
    </div>

    <el-table
      class="table-responsive align-items-center table-flush"
      header-row-class-name="thead-light item-list-head app-th-row"
      highlight-current-row
      header-cell-style="font-size:1.0rem;border-bottom:2px solid #cccccc;color:black;white-space:nowrap;overflow: visible;text-overflow:clip !important;"
      ref="recentList"
      :data="viewModel.list"
      :empty-text="$t('最近使用.5')"
    >
      
      <el-table-column
        prop="type"
        :label="$t('最近使用.2')"
      >
        <template v-slot="{ row }">
          <div class="pl-2">
          <!-- <img :src="iconUrlList[row.iconFilePath]" v-if="row.iconFilePath" class="bg-transparent avatar mr-3" /> -->
          <b>
            <i v-if="row.treeItem.type == 'folder'" class="fa fa-folder-open mr-1 text-default"></i>
            <i v-if="row.treeItem.type == 'backimage'" class="fa fa-layer-group mr-1 text-primary"></i>
            <i v-if="row.treeItem.type == 'map'" class="fa fa-map-marked-alt mr-1 text-primary"></i>
            <i v-if="row.treeItem.type == 'nobackimage'" class="fa fa-bars mr-1 text-primary"></i>
            <i v-if="row.treeItem.type == 'file'" class="far fa-file mr-1 text-primary"></i>
            <a href="#!" @click.prevent="onClickItem(row)"
              >{{ row.treeItem.label }}
            </a>
          </b>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        :label="$t('最近使用.3')"
      >
      <template v-slot="{ row }">
        {{ row.treePlace }}
      </template>
      </el-table-column>

      <el-table-column
        prop="name"
        :label="$t('最近使用.4')"
         width="160px" 
      >
      <template v-slot="{ row }">
        {{ dateStringFormat(row.refDate) }}
      </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style scoped>

</style>
<script>

import TreeViewModel from "@/appViews/components/FileView/ViewModel/TreeViewModel"
import RecentlyViewModel from "@/appViews/Projects/ViewModel/RecentlyViewModel"
import DateUtil from '../../appUtils/DateUtil';

export default {
  components: {
    
  },
  props: {
    /**
     * プロジェクトID
     */
    projectId: String,
    /**
     * CognitoId
     */
    userSub: String
  },
  data() {
    return {
      recentList: [],
      viewModel: null,
      treeViewModel: null,
      loader: null,
      tenantId: ""
    };
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    //インスタンスが生成され､且つデータが初期化された後
    
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
    this.init().then(function(){
      console.log("init")
    })
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: { 
    async init() {
      try {
        this.userInfo = await this.$root.getUserInfo()
        this.tenantId = this.userInfo.group
        this.showLoader()
        this.viewModel = new RecentlyViewModel(this.projectId, this.userSub)
        await this.viewModel.init()
        this.treeViewModel = new TreeViewModel(this.projectId, this.userInfo.sub, this.tenantId)
      } catch (e) {
        console.log(JSON.stringify(e))
      } finally {
        this.hideLoader()

      }
      
    },
    /**
     * 行クリック（親vueに委譲）
     */
    async onClickItem(row) {
      this.$emit("clicked-file", row);
    },
    /**
     * 日付文字を別の形式に変更
     */
    dateStringFormat(dateString) {
      return DateUtil.getFormatString(dateString, "YYYY/MM/DD HH:mm")
    },
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader() {
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#E4007F",
        width: 64,
        height: 64,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        isFullPage: true,
        zIndex: 9999,
      })
    },
    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader() {
      this.loader.hide();
    },
  },
};
</script>
